export default __webpack_public_path__ + "static/media/tagbadge.ef89ed2f.png";